import { allClientSideFlags } from '@gonfalon/constants/constants';
import { getDogfoodClient } from '@gonfalon/dogfood-client/getDogfoodClient';

import { resolveDogfoodFlag } from './resolveDogfoodFlag';

function recordMeticulousFlag(key: string, value: string | boolean) {
  window.Meticulous?.context?.recordFeatureFlag?.(key, value);
}

export function createFlagFunction<T>(flagKey: string, defaultValue: T): () => T {
  const readOverride = () => window.Meticulous?.context?.getFlagOverride?.(flagKey);
  const evaluate = (fallback: T) => {
    try {
      return getDogfoodClient().variation(flagKey, fallback) as T;
    } catch {
      return readBootstrapFlag(flagKey, fallback);
    }
  };
  const deps = { readOverride, record: recordMeticulousFlag, evaluate };

  return () => resolveDogfoodFlag(flagKey, defaultValue, deps);
}

function readBootstrapFlag<T>(flagKey: string, defaultValue: T): T {
  try {
    const flagValue = allClientSideFlags()[flagKey];

    if (typeof flagValue === 'undefined') {
      if (!window.__TEST__) {
        // oxlint-disable-next-line no-console
        console.error(`Flag "${flagKey}" not defined in client-side flags`);
      }

      return defaultValue;
    }

    return flagValue as T;
  } catch {
    return defaultValue;
  }
}
